import { Modal, ModalBody, Spinner } from 'reactstrap';
import Button from '../ui/Button';
import LogoutIcon from '../Icons/LogoutIcon';

interface ILogoutModalProps {
  isOpen: boolean;
  toggle: () => void;
  handleLogout: () => void;
  logoutLoading: boolean;
}
const LogoutModal = ({
  isOpen,
  toggle,
  handleLogout,
  logoutLoading,
}: ILogoutModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody>
        <div className="d-flex flex-column justify-items-center align-items-center gap-4">
          <span className="icon">
            <LogoutIcon />
          </span>
          <p className="text-center mb-4">
            Are you sure, <br /> You want to logout ?
          </p>
          <div className="row m-0 w-100">
            <div className="col-6 ps-0 pe-3">
              <Button
                type="button"
                className="btn btn-danger w-100 fw-medium fs-4"
                onClick={toggle}
              >
                Cancel
              </Button>
            </div>
            <div className="col-6 pe-0 ps-3">
              <Button
                type="button"
                className="btn btn-primary w-100 fw-medium fs-4"
                onClick={handleLogout}
              >
                {logoutLoading ? <Spinner /> : 'Yes'}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default LogoutModal;
